import { render, staticRenderFns } from "./StatsItem.vue?vue&type=template&id=ee064c88&scoped=true"
import script from "./StatsItem.vue?vue&type=script&lang=js"
export * from "./StatsItem.vue?vue&type=script&lang=js"
import style0 from "./StatsItem.vue?vue&type=style&index=0&id=ee064c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee064c88",
  null
  
)

export default component.exports